import type { ResubmitJobResultDto } from 'app/API/models';

export const formatBulkResubmitJobResult = (result?: ResubmitJobResultDto): string => {
  if (!result) {
    return 'Skipped — No Show is enabled';
  }
  if (result.status === 'resubmitted') {
    return 'Resubmitted';
  }
  return `Failed — ${result.error || 'Unable to resubmit job'}`;
};
